<template>
    <div>
        <input-text
            name="contact_form_heading"
            label="Contact Form Heading"
            v-model="form.contact_form_heading"
            class="mt-2"
            :disabled="disabled"
            :error="
                errors.contact_form_heading
                    ? errors.contact_form_heading[0]
                    : null
            "
            :maxlength="255"
        />

        <div class="flex mt-2">
            <input-text
                name="contact_form_anchor"
                label="Contact Form Heading Jump ID (excluding #)"
                v-model="form.contact_form_anchor"
                class="w-full mr-3"
                :disabled="disabled"
                :error="
                    errors.contact_form_anchor
                        ? errors.contact_form_anchor[0]
                        : null
                "
                :maxlength="255"
            />

            <input-text
                name="contact_form_anchor_text"
                label="Quick Navi Menu anchor text for Heading"
                v-model="form.contact_form_anchor_text"
                class="w-full"
                :disabled="disabled"
                :error="
                    errors.contact_form_anchor_text
                        ? errors.contact_form_anchor_text[0]
                        : null
                "
                :maxlength="255"
            />
        </div>

        <input-rich-text
            name="contact_form_text"
            label="Contact Form Text"
            v-model="form.contact_form_text"
            :disabled="disabled"
            :error="
                errors.contact_form_text
                    ? errors.contact_form_text[0]
                    : null
            "
            :maxlength="5000"
        />

    </div>
</template>

<script>
export default {
    name: "BasePageFields",
    props: {
        form: {
            type: Object,
            required: true,
        },
        errors: {
            type: [Array, Object],
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
}
</script>
